import { Capacitor } from "@capacitor/core";

export function resolveApiBaseUrl() {
  const raw = (process.env.REACT_APP_AI_API_BASE_URL || "").trim();
  if (raw) {
    return raw.replace(/\/$/, "");
  }

  // Capacitor (Android/iOS) serves the bundled web assets from
  // https://localhost — there is no backend running there. Always route
  // API calls to the hosted Firebase URL on native.
  const isCapacitor = (() => {
    try {
      if (Capacitor?.isNativePlatform?.()) return true;
    } catch (_) {}
    if (typeof window !== "undefined") {
      if (window.Capacitor?.isNativePlatform?.() === true) return true;
      if (/^capacitor:/i.test(window.location?.protocol || "")) return true;
    }
    return false;
  })();

  if (isCapacitor) {
    return resolveHostedAppBaseUrl();
  }

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isLocalHost = host === "localhost" || host === "127.0.0.1";
  if (isLocalHost) {
    return "http://127.0.0.1:8080";
  }

  return "";
}

export function resolveHostedAppBaseUrl() {
  const projectId = (process.env.REACT_APP_FIREBASE_PROJECT_ID || "").trim();
  if (!projectId) {
    return "";
  }

  return `https://${projectId}.web.app`;
}